﻿import React, {JSX, useMemo} from "react";
import {useControlId} from "../helpers/useControlId";
import {HtmlControlProps} from "./HtmlControlProps";

export interface CheckboxProps extends HtmlControlProps<HTMLInputElement> {
	hint?: string,
	description?: string,
	checked?: boolean;
	arrayKey?: string;
}

export default function Checkbox(props: CheckboxProps): JSX.Element {
	const {
		label,
		name,
		value,
		id,
		column,
		disabled,
		hidden,
		onChange,
		onBlur,
		ref,
		hint,
		description,
		checked,
		arrayKey
	} = props;

	const controlId = useControlId(id);
	const hintId = controlId + "-hint";
	const hasHint = hint != null;
	const klass = useMemo(() => "labelled-field" + (column ? ` ${column}` : ""), [column]);

	if (hidden) {
		return <></>;
	}

	return <div className={klass}>
		<div className="form__field form__field--checkbox">
			<input type="checkbox"
			       ref={ref}
			       id={controlId}
			       name={name}
			       onChange={onChange}
			       onBlur={onBlur}
			       value={value}
			       data-array-key={arrayKey}
			       tabIndex={disabled ? -1 : undefined}
			       readOnly={disabled}
			       disabled={disabled}
			       checked={onChange == null ? undefined : checked}
			       defaultChecked={onChange == null ? checked : undefined}/>
			<label className="checkbox__label" htmlFor={controlId}>
				<span className="label__text">{label}</span>
			</label>
			{hasHint && <span id={hintId} className="field__hint">{hint}</span>}
		</div>
	</div>;
}
